import { render } from "./HomeView.vue?vue&type=template&id=87df77e4"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=87df77e4&lang=scss"

import exportComponent from "D:\\xurshid\\PROJECTS\\fvvga\\sayt\\vue_asosiy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__